import type { ChefFood } from './food-types'
export type EstimateItem = { date: string; foodName: string; enterpriseName: string; estimate: number }
import { apiConfig } from "./client";

export const foodApi = {
  list: async (signal?: AbortSignal) => {
    const response = await apiConfig.get<ChefFood[]>("/api/front/chef/foods", { signal });
    return response;
  },
  updatePrice: async (foodId: string, price: number) => {
    const response = await apiConfig.patch(
      `/api/front/chef/food-price/${foodId}/${price}`,
    
    );
    return response;
  },
  estimate: async (signal?: AbortSignal) => {
    const response = await apiConfig.get<EstimateItem[]>("/api/front/chef/estimate", { signal });
    return response;
  },
};
